import { FormsConstants } from '../../types/forms-constants';

export type ServiceActivityState = Readonly<FormsConstants.SERVICE_ACTIVITY_TYPES | undefined>;

export const initialServiceActivityState: Readonly<ServiceActivityState> = undefined;
